import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { styled } from "@mui/material/styles";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
// Our components
import Carrier from '../General/Carrier'
import NorowsData from '../General/NorowsData'
import Date from '../../pages/General/Date'
import Notification from '../../pages/General/Notification';
import Filters from './Filters';
import Search from './Search';
import PageSearch from '../../pages/General/PageSearch'
// mui components
import {
    Typography,
    InputAdornment,
    FormControl,
    Pagination,
    Tooltip,
    Card,
    CardHeader,
    CardContent,
    Divider,
    IconButton
} from "@mui/material";
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';


import { fetchClaimsData, storeClaimsData, resetClaimsState } from './claimsSlice';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper'
};
const Input = styled("input")({
    display: "none",
  });
  const Input1 = styled("input")({
    display: "none",
  });

const UploadDashedBox = styled(Box)(({ theme, hasError }) => ({
    width: '100%',
    padding: '16px 20px',
    borderRadius: '10px',
    border: '2px dashed',
    borderColor: hasError ? '#d32f2f' : '#CBD5E1',
    backgroundColor: '#F8FAFC',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        borderColor: hasError ? '#c62828' : '#1E293B',
        backgroundColor: '#F1F5F9'
    }
}));

const formFieldStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': { borderColor: '#CBD5E1' },
        '&.Mui-focused': {
            borderColor: '#1E293B',
            boxShadow: '0 0 0 3px rgba(30, 41, 59, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 12px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1E293B',
            fontWeight: 600
        }
    },
    '& .MuiSelect-select, & input': {
        padding: '11px 14px',
        fontSize: '14px',
        color: '#1E293B'
    }
};
// Reusable action button micro-interaction layout override style object
const columnActionIconStyles = {
    color: '#1976d2', // --- SNAPS ACTION ICONS TO CORPORATE BLUE SYSTEM ACCENT ---
    padding: '8px',
    borderRadius: '8px',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: 'rgba(25, 118, 210, 0.06)',
        transform: 'scale(1.05)'
    }
};
// Shared enterprise style object for the uniform action utilities matrix
const claimsUtilityIconStyles = (isActive) => ({
    color: '#1976d2', // --- FIXED CORPORATE ACCENT BLUE MATRIX BRAND TOKEN ---
    padding: '8px',
    borderRadius: '10px',
    backgroundColor: isActive ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
    border: isActive ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid #E2E8F0',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: isActive ? 'rgba(25, 118, 210, 0.12)' : 'rgba(241, 245, 249, 0.8)',
        borderColor: isActive ? 'rgba(25, 118, 210, 0.3)' : '#CBD5E1',
        transform: 'translateY(-1px)'
    },
    '&:active': {
        transform: 'translateY(0)'
    }
});
const ClaimsPage = () => {

    const dispatch = useDispatch();
    const claims = useSelector(state => state.claims);
    const profile = useSelector(state => state.auth.profile);  
    const [meta, setMeta] = useState(claims.meta);
    const [modalVisible, setModalVisible] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [fileName, setFileName] = useState([])
    const [invoiceFileName, setInvoiceFileName] = useState("")
    const [invoiceFileError, setInvoiceFileError] = useState("")
    const [invoiceFileUpload, setInvoiceFileUpload] = useState("");
    const [pageNumber, setPageNumber] = useState("")
    const initialValues = {
        tracking_number:"",
        package_value: "",
        claim_type: "",
        claim_status: "PENDING",
        file:[]
      };
      const [values, setValues] = useState(initialValues);
      const [errors, setErrors] = useState({});   
      
      const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('tracking_number' in fieldValues)
            temp.tracking_number = fieldValues.tracking_number ? "" : "This field is required."
        if (values.claim_type === 'UNUSED') {
            temp.package_value = ""; 
        } else {
            if ('package_value' in fieldValues) {
                const val = fieldValues.package_value;
                if (!val) {
                    temp.package_value = "This field is required.";
                } else if (isNaN(val) || parseFloat(val) <= 0) {
                    // ADDED: Check if value is greater than zero
                    temp.package_value = "Value must be greater than zero.";
                } else {
                    temp.package_value = "";
                }
            }
        }
        if ('claim_type' in fieldValues)
            temp.claim_type = fieldValues.claim_type ? "" : "This field is required."
        if(values.claim_type==='DAMAGE'){
            if ('file' in fieldValues)
                temp.file = fieldValues.file ? "" : "This field is required."
        }
        setErrors({
            ...temp
        })

        if (fieldValues === values) {
            return Object.values(temp).every(x => x == "")
        }
    }

    const onInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
        validator({ [name]: value })
    }
   
       const onFileUpload = (e, field_name) => {
            if (field_name === 'damageproof') {
                const files = Array.from(e.target.files); // ✅ Flatten FileList
                const previewUrls = files.map(file => URL.createObjectURL(file));
                setFileName(previewUrls); // For preview display
                setValues(prev => ({
                ...prev,
                file: files // ✅ Store flat array of File objects
                }));
                validator({ file: files });
            } else {
                // Invoice file upload
                if (e.target.files && e.target.files.length > 0) {
                const file = e.target.files[0];
                setInvoiceFileUpload(file);
                setInvoiceFileName(URL.createObjectURL(file));
                }
            }
        };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isValid = validator(values);
        if (isValid) {
            if ((values.claim_type !== 'UNUSED' && invoiceFileUpload) || values.claim_type === 'UNUSED') {
                const formData = new FormData();
                formData.append("invoice_file", invoiceFileUpload);
                formData.append("tracking_number", values.tracking_number);
                
                // If claim type is UNUSED, append 0, otherwise append actual input value ---
                formData.append("package_value", values.claim_type === 'UNUSED' ? 0 : values.package_value);
                
                formData.append("claim_type", values.claim_type);
                formData.append("claim_status", "PENDING");

                if (values.claim_type === 'DAMAGE') {
                    values.file.forEach(file => {
                        formData.append("file[]", file); // ✅ Append each file
                    });
                }

                // Optional: log FormData contents
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                dispatch(storeClaimsData(profile?.id, formData, meta));
                onModalClose();
                setInvoiceFileError("");
            } else {
                setInvoiceFileError("Commercial invoice file is required");
            }
        }
    };

    const multipleImageOpen = (e,urls) => {
        e.preventDefault();
        urls.map((item) => (
            window.open(item)
        ))
      };
    const columns = [
        {
            field: 'tracking_number',
            headerName: 'Tracking number',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => (
                <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#1E293B' }}>
                    {params.value}
                </Typography>
            )
        },
        {
            field: 'claim_type',
            headerName: 'Claim type',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 150,
            renderCell: (params) => {
                const chipStyles = {
                    width: '120px',
                    height: '26px',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    border: 'none'
                };

                if (params.row.claim_type == 'LOST') {
                    return <Chip label={params.row.claim_type} sx={{ ...chipStyles, backgroundColor: '#1976d2' }} />;
                } else if (params.row.claim_type == 'DAMAGE') {
                    return <Chip label={params.row.claim_type} sx={{ ...chipStyles, backgroundColor: '#EF4444' }} />;
                } else if (params.row.claim_type == 'UNUSED') {
                    return <Chip label={params.row.claim_type} sx={{ ...chipStyles, backgroundColor: '#8B5CF6' }} />;
                } else {
                    return <Chip label={params.row.claim_type} sx={{ ...chipStyles, backgroundColor: '#F59E0B' }} />;
                }
            }  
        },
        {
            field: 'package_value',
            headerName: 'Commercial Value of Package',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'right',
            headerAlign: 'right',
            minWidth: 200,
            renderCell: (params) => (
                <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#334155', fontFamily: 'monospace' }}>
                    {"$" + params.row.package_value}
                </Typography>
            )
        },
        {
            field: 'claim_status',
            headerName: 'Claim Status',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                const statusStyles = {
                    width: '120px',
                    height: '26px',
                    fontSize: '12px',
                    fontWeight: 700,
                    borderRadius: '6px',
                    border: 'none'
                };

                if (params.row.claim_status == 'PENDING') {
                    return <Chip label={params.row.claim_status} sx={{ ...statusStyles, backgroundColor: 'rgba(25, 118, 210, 0.08)', color: '#1976d2' }} />;
                } else if (params.row.claim_status == 'APPROVED') {
                    return <Chip label={params.row.claim_status} sx={{ ...statusStyles, backgroundColor: 'rgba(16, 185, 129, 0.08)', color: '#10B981' }} />;
                } else if (params.row.claim_status == 'DENIED') {
                    return <Chip label={params.row.claim_status} sx={{ ...statusStyles, backgroundColor: 'rgba(239, 68, 68, 0.08)', color: '#EF4444' }} />;
                }
            }
        },
        {
            field: 'claimsurl',
            headerName: 'Document',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 100,
            renderCell: (params) => {
                // Convert JSON string to an arrayf
                let urlArray = [];
                if (params && params.row && params.row.claimsurl && params.row.claimsurl !== '') {
                    urlArray = JSON.parse(params.row.claimsurl);
                    console.log(urlArray.length);
                }

                if (urlArray.length > 1) {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Tooltip title="View Multiple Documents" placement="top">
                                <IconButton 
                                    onClick={(e) => multipleImageOpen(e, urlArray)}
                                    sx={columnActionIconStyles}
                                >
                                    <RemoveRedEyeIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    );
                } else if (urlArray.length === 1) {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Tooltip title="View Document" placement="top">
                                <IconButton 
                                    onClick={() => window.open(urlArray, '_blank')}
                                    sx={columnActionIconStyles}
                                >
                                    <RemoveRedEyeIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    );
                } else {
                    return <Typography sx={{ color: '#94A3B8', fontWeight: 500 }}>-</Typography>;
                }
            }
        },
        {
            field: 'invoice_url',
            headerName: 'Invoice',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 100,
            renderCell: (params) => {
                if (params && params.row && params.row.invoice_url && params.row.invoice_url !== '') {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Tooltip title="View Invoice" placement="top">
                                <IconButton 
                                    onClick={() => window.open(params.row.invoice_url, '_blank')}
                                    sx={columnActionIconStyles}
                                >
                                    <RemoveRedEyeIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    );
                } else {
                    return <Typography sx={{ color: '#94A3B8', fontWeight: 500 }}>-</Typography>;
                }
            }
        },
        {
            field: 'created_at',
            headerName: 'Claim Submitted at',
            headerClassName: 'super-app-theme--header',
            minWidth: 150,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', fontSize: '13.5px', color: '#475569', fontWeight: 500 }}>
                    <Date date={params.row.created_at} />
                </Box>
            )         
        },
        {
            field: 'refund_amount',
            headerName: 'Refunded Amount',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: 'right',
            headerAlign: 'right',
            minWidth: 150,
            renderCell: (params) => {
                let refundAmount = 0;
                if (params && params.row && params.row.refund_amount && params.row.refund_amount != '') {
                    refundAmount = params.row.refund_amount;
                }
                return (
                    <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: '#10B981', fontFamily: 'monospace' }}>
                        {"$" + refundAmount}
                    </Typography>
                );
            }
        },
        {
            field: 'invoice_number',
            headerName: 'Adjusted Invoice Number',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 250,
            renderCell: (params) => {
                if (params && params.row && params.row.invoice_number && params.row.invoice_number != '') {
                    return (
                        <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#475569' }}>
                            {params.row.invoice_number}
                        </Typography>
                    );
                } else {
                    return <Typography sx={{ color: '#94A3B8', fontWeight: 500 }}>-</Typography>;
                }
            }
        }
    ];

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    const onInputChangePagination = (page) => {
        setPageNumber(page)
        let pagenumber = ''
        if (page == '') {
            pagenumber = 1
        } else {
            pagenumber = page
        }
        setMeta({
            ...meta,
            ...{
                page: pagenumber
            }
        });
    }

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }

    // ==========================================
    // PART 1: SUB-COMPONENTS ARCHITECTURE (TOOLBAR & PAGINATION)
    // ==========================================

    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows" 
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontSize: '12.5px', 
                        fontWeight: 600, 
                        color: '#475569',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        letterSpacing: '0.1px'
                    }}
                >
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {claims && claims.data && claims.data.length}
                    </strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {(claims && claims.meta && claims.meta.total) ? claims.meta.total : 0}
                    </strong>
                </Typography>
            </Box>
        );
    }

    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        Show
                    </Typography>
                    
                    <FormControl 
                        size="small" 
                        variant="outlined" 
                        sx={{
                            minWidth: 75,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.2s',
                                border: '1px solid #E2E8F0',
                                '& fieldset': { border: 'none' },
                                '&:hover': { borderColor: '#CBD5E1' },
                                '&.Mui-focused': {
                                    borderColor: '#1976d2',
                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                }
                            },
                            '& .MuiSelect-select': {
                                padding: '6px 10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1E293B',
                                textAlign: 'center'
                            }
                        }}
                    >
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                        border: '1px solid #E2E8F0',
                                        '& .MuiMenuItem-root': {
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            py: 0.8,
                                            color: '#334155',
                                            '&.Mui-selected': {
                                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                color: '#1976d2',
                                                fontWeight: 700
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        entries
                    </Typography>
                </Stack>
            </Box>
        );
    }

    // Fixed container setup to eliminate default overlap/clipping issues at the top of the table canvas
    function CustomToolbar() {
        return (
            <Box 
                sx={{ 
                    p: '12px 16px', // Premium padding footprint density
                    bgcolor: '#F8FAFC', 
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between', // Pushes item 1 to far-left, item 2 to far-right automatically
                    width: '100%',
                    boxSizing: 'border-box',
                    gap: 2
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </Box>
        );
    }

    function CustomPagination() {
        return (
            <Box
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    // Modernizes the standard MUI pagination controls
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2', // --- CORPORATE BLUE IDENTITY ACCENT ---
                            color: '#FFFFFF',
                            '&:hover': {
                                backgroundColor: '#115293'
                            }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={claims && claims.meta && claims.meta.current_page}
                    count={claims && claims.meta && claims.meta.last_page}
                    onChange={onChangePagination}
                />
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <PageSearch 
                        pagenumber={pageNumber} 
                        lastPage={claims?.meta?.last_page || 1} 
                        getpagenumber={onInputChangePagination} 
                    />
                </Box>
            </Box>
        );
    }

    const onModalClose = () => {
        setModalVisible(false)
        setErrors({})
        setFileName([])
        setValues(initialValues)
        setInvoiceFileName("")
        setInvoiceFileUpload("")
        setInvoiceFileError("")
    }


    useEffect(() => {
        dispatch(fetchClaimsData(meta));
    }, [meta]);

    return (
        <>

            <Modal
                open={modalVisible}
                onClose={onModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 560, md: 600 },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none'
                }}>
                    <Card sx={{ borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', border: '1px solid #E2E8F0' }}>
                        <CardHeader 
                            title={<Typography variant="h6" sx={{ fontWeight: 800, color: '#1E293B' }}>Submit Claim</Typography>} 
                            sx={{ bgcolor: '#F8FAFC', p: 2.5 }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        <CardContent sx={{ p: 4 }}>
                            <Stack spacing={3}>
                                
                                {/* 1. Claim Type */}
                                <FormControl fullWidth variant="outlined" error={errors.claim_type} sx={formFieldStyles}>
                                    <InputLabel id="claim-type-label">Claim Type*</InputLabel>
                                    <Select
                                        labelId="claim-type-label"
                                        id="claim-type-select"
                                        name="claim_type"
                                        defaultValue={values && values.claim_type}
                                        onChange={onInputChange}
                                        label="Claim Type"
                                    >
                                        <MenuItem value={"LOST"}>Lost</MenuItem>
                                        <MenuItem value={"DAMAGE"}>Damage</MenuItem>
                                        <MenuItem value={"MISDELIVERY"}>Misdelivery</MenuItem>
                                        <MenuItem value={"MISSING"}>Missing</MenuItem>
                                        <MenuItem value={"UNUSED"}>Unused</MenuItem>
                                    </Select>
                                    {errors.claim_type && <FormHelperText sx={{ ml: 0.5, mt: '6px' }}>{errors.claim_type}</FormHelperText>}
                                </FormControl>

                                {/* 2. Tracking Number */}
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    sx={formFieldStyles}
                                    label="Tracking Number*"
                                    name="tracking_number"
                                    defaultValue={values && values.tracking_number}
                                    onChange={onInputChange}
                                    error={errors.tracking_number}
                                    helperText={errors.tracking_number}
                                />

                                {/* 3. Commercial Value of Package (With dynamic Profile Currency code) */}
                                {values && values.claim_type !== 'UNUSED' && (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={formFieldStyles}
                                        label="Commercial Value of Package*"
                                        type="text"
                                        name="package_value"
                                        defaultValue={values && values.package_value}
                                        onChange={onInputChange}
                                        error={errors.package_value}
                                        helperText={errors.package_value}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Typography sx={{ fontWeight: 700, fontSize: '13px', color: '#64748B', mr: 0.5 }}>
                                                        {profile?.currency_code || ""}
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}

                                {/* 4. Damage Proof Attachments Box */}
                                {values && values.claim_type === 'DAMAGE' && (
                                    <Box>
                                        <label htmlFor="contained-button-file-damage" style={{ width: '100%', display: 'block' }}>
                                            <Input
                                                accept="image/*,application/pdf"
                                                id="contained-button-file-damage"
                                                onChange={(e) => onFileUpload(e, "damageproof")}
                                                multiple
                                                name="file"
                                                type="file"
                                            />
                                            <UploadDashedBox hasError={errors.file}>
                                                <CloudUploadIcon sx={{ color: errors.file ? '#d32f2f' : '#64748B', fontSize: 24 }} />
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#334155' }}>
                                                        Upload Damage Package Proof
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#94A3B8', display: 'block' }}>
                                                        Images or PDF documentation
                                                    </Typography>
                                                </Box>
                                            </UploadDashedBox>
                                        </label>
                                        
                                        {fileName.length > 0 && (
                                            <Stack spacing={0.5} sx={{ mt: 1.5, pl: 0.5 }}>
                                                {fileName.map((url, index) => (
                                                    <Box key={index} display="flex" alignItems="center" gap={1}>
                                                        <AttachFileIcon sx={{ fontSize: 13, color: '#64748B' }} />
                                                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#475569', fontSize: '11px' }}>
                                                            Filename: {url}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Stack>
                                        )}
                                        {errors.file && <FormHelperText error sx={{ ml: 0.5, mt: '6px' }}>{errors.file}</FormHelperText>}
                                    </Box>
                                )}

                                {/* 5. Invoice Upload Box */}
                                <Box>
                                    <label htmlFor="contained-button-file-invoice" style={{ width: '100%', display: 'block' }}>
                                        <Input
                                            accept="application/pdf"
                                            id="contained-button-file-invoice"
                                            onChange={(e) => onFileUpload(e, "invoice_file")}
                                            name="invoice_file"
                                            type="file"
                                            style={{ display: "none" }}
                                        />
                                        <UploadDashedBox hasError={invoiceFileName === "" && invoiceFileError}>
                                            <CloudUploadIcon sx={{ color: (invoiceFileName === "" && invoiceFileError) ? '#d32f2f' : '#64748B', fontSize: 24 }} />
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 700, color: '#334155' }}>
                                                    Upload Invoice Documentation
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#94A3B8', display: 'block' }}>
                                                    PDF format required
                                                </Typography>
                                            </Box>
                                        </UploadDashedBox>
                                    </label>
                                    
                                    {invoiceFileName && (
                                        <Box display="flex" alignItems="center" gap={1} sx={{ mt: 1.5, pl: 0.5 }}>
                                            <AttachFileIcon sx={{ fontSize: 13, color: '#64748B' }} />
                                            <Typography variant="caption" sx={{ fontWeight: 600, color: '#475569', fontSize: '11px' }}>
                                                Filename: {invoiceFileName}
                                            </Typography>
                                        </Box>
                                    )}
                                    {invoiceFileName === "" && invoiceFileError && (
                                        <FormHelperText error sx={{ ml: 0.5, mt: '6px' }}>{invoiceFileError}</FormHelperText>
                                    )}
                                </Box>

                            </Stack>

                            <Divider sx={{ my: 3.5, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                            {/* Footer Action Controls Row */}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    onClick={onModalClose}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        px: 3.5,
                                        borderColor: '#E2E8F0',
                                        color: '#475569',
                                        '&:hover': {
                                            borderColor: '#CBD5E1',
                                            backgroundColor: '#F1F5F9',
                                            color: '#1E293B'
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        px: 5,
                                        boxShadow: 'none',
                                        backgroundColor: '#1E293B',
                                        color: '#FFFFFF',
                                        '&:hover': {
                                            backgroundColor: '#0F172A',
                                            boxShadow: 'none'
                                        }
                                    }}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            {(claims && claims.notification && claims.notification.messageContent!='') &&
            <Notification
                is_open={claims.notification.show}
                messageType={claims.notification.messageType}
                messages={claims.notification.messageContent}
                handleClose={() => dispatch(resetClaimsState())}
            />}
            <div className="scmaincard">
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        pb: 2.5,
                        pt: 1,
                        flexWrap: 'wrap',
                        gap: 2,
                        boxSizing: 'border-box'
                    }}
                >
                    {/* Section Heading Area Container Node */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography 
                            variant="h5" 
                            component="h1" 
                            sx={{ 
                                fontWeight: 800, 
                                color: '#0F172A',
                                letterSpacing: '-0.5px',
                                margin: 0
                            }}
                        >
                            Claims
                        </Typography>
                    </Box>

                    {/* Operational Control Toolbar Component Box Layout Container */}
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            gap: 1.5
                        }}
                    >
                        <Box 
                            className="features-list"
                            component="div"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.2,
                                p: 0,
                                m: 0
                            }}
                        >
                            {/* 1. High-Priority Primary Modal Pipeline Action Trigger Button */}
                            <Tooltip title="Create new order" placement="top">
                                <Button 
                                    variant="outlined" 
                                    onClick={() => { setModalVisible(true) }}
                                    startIcon={<AddCircleOutlineRoundedIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        px: 2.2,
                                        borderColor: '#1976d2',
                                        color: '#1976d2',
                                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                        '&:hover': {
                                            borderColor: '#115293',
                                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                            transform: 'translateY(-1px)'
                                        },
                                        '&:active': {
                                            transform: 'translateY(0)'
                                        },
                                        '& .MuiButton-startIcon': {
                                            marginRight: '6px'
                                        }
                                    }}
                                >
                                    New Claim
                                </Button>
                            </Tooltip>

                            {/* 2. Interactive Search Panel Toggle Utilities Trigger */}
                            <Tooltip title="Search" placement="top">
                                <IconButton 
                                    sx={claimsUtilityIconStyles(showSearch)} 
                                    onClick={() => onMenuClick("search", !showSearch)}
                                >
                                    <SearchIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </Tooltip>

                            {/* 3. Interactive Filter Panel Toggle Utilities Trigger */}
                            <Tooltip title="Filter" placement="top">
                                <IconButton 
                                    sx={claimsUtilityIconStyles(showFilter)} 
                                    onClick={() => onMenuClick("filter", !showFilter)}
                                >
                                    <FilterAltOutlinedIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>
                {showSearch && <Search visible={showSearch} meta={meta} setMeta={setMeta} />}
                {showFilter && <Filters visible={showFilter} meta={meta} setMeta={setMeta} />}
                <Box 
                    sx={{ 
                        backgroundColor: '#FFFFFF', 
                        mt: 3, 
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden'
                    }}
                >
                    {/* Rendering the toolbar directly inside our wrapper layer prevents it from being hidden behind headers */}
                    <CustomToolbar />

                    <DataGrid
                        sx={{
                            border: 'none',
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            
                            '& .MuiDataGrid-topContainer': {
                                backgroundColor: '#F8FAFC',
                                '&::after': { display: 'none' }
                            },
                            
                            // Customizing Enterprise Header Styling
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#F8FAFC',
                                borderBottom: '1px solid #E2E8F0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                color: '#475569',
                                fontWeight: 700,
                                fontSize: '13px',
                                textTransform: 'none',
                                letterSpacing: '0.1px',
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },
                            
                            // Customizing Rows and Cells Layout Bounds
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease-in-out',
                                borderBottom: '1px solid #F1F5F9',
                                alignItems: 'center',
                                '&:hover': {
                                    backgroundColor: '#F8FAFC'
                                }
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '13.5px',
                                color: '#334155',
                                borderBottom: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                py: '12px', 
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },

                            // Custom Linear Progress bar tracking layout styling overrides
                            '& .MuiLinearProgress-root': {
                                height: '3px',
                                backgroundColor: '#E2E8F0',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#1976d2'
                                }
                            }
                        }}
                        getRowId={(row) => row.id}
                        rows={claims && claims.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        slots={{
                            loadingOverlay: LinearProgress,
                            footer: CustomPagination, // Injected into the footer layer slot
                            NorowsData
                        }}
                        loading={(claims && claims.loading)}
                    />
                </Box>
            </div >
        </>
    );
}

export default ClaimsPage;